import { queryClient } from "@/App";
import ArquivoConteudo from "@/Models/Domain/Servico/ArquivoConteudo";
import { Axios } from "@/Services/Axios";
import { MutationBasicaParam, QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useArquivoConteudoListarDiretorio({
    caminho,
    ...rest
}:QueryBasicaParam<AxiosResponse<ArquivoConteudo[]>, ArquivoConteudo[], {
    caminho?:string;
}>) {
    const caminhoUrl = new URLSearchParams({ caminho : caminho ?? '/' }).toString();

    return useQuery({
        ...rest,
        queryKey : [ "Domain.Servico.ArquivoConteudo.diretorio", `Domain.Servico.ArquivoConteudo.diretorio.?${caminhoUrl}` ],
        queryFn : () => Axios.get<ArquivoConteudo[]>(`domain/servico/ArquivoConteudo/diretorio?${caminhoUrl}`),
        select(data) {
            return data.data.map(m => {
                m.updatedAt = new Date(m.updatedAt as any);
                return m;
            });
        }
    }, queryClient);
}

export function useArquivoConteudoCriarPasta({
    onSuccess,
    ...rest
}:MutationBasicaParam<ArquivoConteudo, AxiosResponse<ArquivoConteudo>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios.post<ArquivoConteudo>(`domain/servico/ArquivoConteudo/pasta`, dataRequest);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Domain.Servico.ArquivoConteudo.diretorio",  `Domain.Servico.ArquivoConteudo.diretorio.?${entrada.path ?? '/'}`] });
            onSuccess?.(retorno, entrada, context);
        }
    }, queryClient);
}

export function useArquivoConteudoDeletar({
    onSuccess,
    ...rest
}:MutationBasicaParam<ArquivoConteudo[], AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios.post<void>(`domain/servico/ArquivoConteudo/deletar`, dataRequest);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Domain.Servico.ArquivoConteudo.diretorio"] });
            onSuccess?.(retorno, entrada, context);
        }
    }, queryClient);
}



export function useArquivoConteudoRenomear({
    onSuccess,
    ...rest
}:MutationBasicaParam<{novo:string, atual:ArquivoConteudo}, AxiosResponse<ArquivoConteudo>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios.patch<ArquivoConteudo>(`domain/servico/ArquivoConteudo/nome`, {
                path : dataRequest.atual.path,
                name : dataRequest.novo
            });
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Domain.Servico.ArquivoConteudo.diretorio"] });
            onSuccess?.(retorno, entrada, context);
        }
    }, queryClient);
}

export function useArquivoConteudoBaixar({
    onSuccess,
    ...rest
}:MutationBasicaParam<ArquivoConteudo, AxiosResponse<Blob>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios.post<Blob>(
                `domain/servico/ArquivoConteudo/baixar`, 
                dataRequest,
                {
                    responseType: "blob"
                }
            );
        },
        onSuccess : (retorno, entrada, context) => {
            onSuccess?.(retorno, entrada, context);
        }
    }, queryClient);
}

